/**
 * Agend Data Layer - Elementor Add to Cart Widget Tracking
 *
 * Tracks when users click Elementor Custom Add to Cart widget links
 * and pushes GA4 add_to_cart event to dataLayer.
 */

import { isTrackingEnabled, createItemData, pushAddToCartEvent } from './tracking-utils';

(function () {
	'use strict';

	document.addEventListener('DOMContentLoaded', function () {
		// Check if Elementor Add to Cart tracking is enabled
		if (!isTrackingEnabled('elementorAddToCartEnabled')) {
			return;
		}

		/**
		 * Extract product data from element's data attributes
		 *
		 * @param {HTMLElement} element - Button element
		 * @return {Array} Array with single product or empty array
		 */
		function getElementorProductData(element) {
			// Check if this is an Elementor-tracked element
			if (!element.dataset.elementorTrack) {
				return [];
			}

			const productId = element.dataset.productId;
			const productName = element.dataset.productName;

			// Validate required fields
			if (!productId || !productName) {
				return [];
			}

			// Use shared utility to create item data
			const productData = createItemData({
				sku: element.dataset.productSku || productId,
				name: productName,
				price: parseFloat(element.dataset.productPrice) || 0,
				quantity: parseInt(element.dataset.quantity, 10) || 1,
				category: element.dataset.productCategory || ''
			});

			return [productData];
		}

		/**
		 * Handle clicks on Elementor Add to Cart buttons
		 */
		const buttons = document.querySelectorAll('a[data-elementor-track]');

		buttons.forEach(function (button) {
			button.addEventListener('click', function (e) {
				const items = getElementorProductData(button);

				// Push to dataLayer using shared utility
				pushAddToCartEvent(items);
			});
		});
	});

})();
